import { useContext } from "react";
import { useDispatch } from "react-redux";
import { NavigationContext } from "../../Context/NavigationContext";
import { getDataReader } from "../../livedataFuncs";
import { NavObjectType } from "../navigationTypes";
import { ThirdPartyDispatch } from "../ThirdPartyList/ThirdPartyFuncs";
import { selectBranchLink } from "./MortgageLenderFuncs";
import { useAppSelector } from "../../redux/hooks";
import { lddStateObject } from "../../redux/reducer";
import { LenderContactType } from "./MortgageLenderTypes";
import React from "react";

export function buildDischargeLenderHeaders(
    listColumns: string[],
    handleColumnClick: (columnAttr: string) => void,
    provinceShort: string,
    getSortIcon: (columnAttr: string) => JSX.Element,
) {
    const handleClick = (columnAttr: string) => {
        handleColumnClick(columnAttr);
    }
    return (
        <tr>
            <React.Fragment>
                <th></th>
                <th onClick={() => handleClick("Branch")} style={{cursor: 'pointer'}}>
                    {getSortIcon("Branch")}
                    Name
                </th>
            </React.Fragment>
        </tr>
    )
}

export type DischargeListItem = {
    LenderContactID: number,
    LDDLenderID: number,
    LenderID: number,
    Branch: string,
    XMLData: string,
    SortOrder: number,
    isDischarge: number,
    selectBranch?: LenderContactType;
}

export function buildDischargeLenderLink() {
    return (DischargeEntry: DischargeListItem) => {
        return (
            <DischargeLink
                DischargeEntry={DischargeEntry}
                key={`${DischargeEntry['LenderContactID']}-${DischargeEntry['LDDLenderID']}`} />
        )
    }
}

type DischargeLinkType = {
    DischargeEntry: DischargeListItem,
}

const DischargeLink = (props: DischargeLinkType) => {
    const livedataRootContainer = useAppSelector((state: lddStateObject) => state.currentNavigation.livedataRootContainer);
    const dispatch = useDispatch();
    let id, psm, mortgageNodesLength;
    if (livedataRootContainer?.dataRoot) {
        const DataReaderObj = getDataReader(livedataRootContainer.dataRoot);
        mortgageNodesLength = DataReaderObj.getMortgageNodesLength();
        id = DataReaderObj.getAppId();
        psm = DataReaderObj.getPSM();
    }
    const editBranch: NavObjectType = {
        component: "main",
        url: "lfmaster.asp",
        params: {
            "tb": "TPAppXML",
            "formasp": "purfileedit",
            "id": id,
            "PSM": psm,
        },
        controller: {
            tabName: "Mortgages",
            tabNumber: mortgageNodesLength,
        },
    }
    const nav = useContext(NavigationContext);
    return (
        <tr onClick={async () => {
            try {
                selectBranchLink(props.DischargeEntry);
                ThirdPartyDispatch(dispatch, 'MortgageLender', false);
                nav(editBranch);
            } catch (e) {

            }
        }}>
            <td />
            <td>{props.DischargeEntry['Branch']}</td>
        </tr>
    )
}